module.exports = __webpack_public_path__ + "img/pantalla-6-7.ff129567.png";